<template>
<!-- 轨迹回放 -->
  <div style="width: 100%;height: 100%;" id="container"></div>
</template>

<script>
import remoteLoad from '@/utils/remoteLoad'
export default {
  data() {
    return {
      AutoNaviMap: null,
      this: [],
    }
  },
  watch: {},
  //DOM树之前触发 异步加载有问题  index 全局加载
  async created() {
    // 高德地图API判断，已加载初始化地图
    if (window.AMap && window.AMapUI) {
      this.mapInit('container')
    } else {
      // 未载入高德地图API，则先载入API再初始化
      // await remoteLoad(`//cache.amap.com/lbs/static/es5.min.js`)
      await remoteLoad(
        `//webapi.amap.com/maps?v=1.4.15&key=2cbb0fe7670495938085430e3825062a&plugin=AMap.MarkerClusterer,AMap.Geocoder`
      )
      this.mapInit('container')
    }
  },

  mounted() {
    // this.mapInit('container');
  },
  methods: {
    mapInit(domName) {
      this.AutoNaviMap = new window.AMap.Map(domName, {
        resizeEnable: true, //是否监控地图容器尺寸变化
        center: [104.421316, 31.131339],
        mapStyle: "amap://styles/79119bc8efdedfee808f56731a684a65",
        zoom: 17, //初始化地图层级
      })

      this.$emit('amapDone') //完成加载 通知父组件
    },
    replaying() {
      var marker
      var lineArr = [
        [104.421316, 31.131339],
        [104.421364, 31.131233],
        [104.421391, 31.131127],
        [104.421423, 31.131022],
        [104.421461, 31.130893],
        [104.421294, 31.128873],
        [104.420908, 31.124822],
        [104.420693, 31.122953],
        [104.420388, 31.121167],
        [104.42005, 31.119371],
        [104.419722, 31.117539],
        [104.419588, 31.116643],
        [104.419492, 31.115665],
        [104.419513, 31.114471],
        [104.419562, 31.11262],
        [104.419658, 31.110434],
        [104.419776, 31.107701],
        [104.419846, 31.105235],
        [104.419958, 31.102777],
        [104.420012, 31.101202],
        [104.420012, 31.100297],
        [104.419975, 31.099773],
        [104.41991, 31.099319],
        [104.419857, 31.098878],
        [104.419765, 31.098377],
        [104.419653, 31.097876],
        [104.419524, 31.097376],
        [104.419374, 31.09687],
        [104.419186, 31.096393],
        [104.418912, 31.09569],
        [104.418644, 31.095106],
        [104.418204, 31.094201],
        [104.417754, 31.093297],
        [104.417453, 31.092653],
        [104.416922, 31.091606],
        [104.416649, 31.091013],
        [104.416252, 31.09021],
        [104.415731, 31.089158],
        [104.415458, 31.088574],
        [104.414991, 31.087747],
        [104.414299, 31.086714],
        [104.413736, 31.08607],
        [104.412883, 31.085188],
        [104.412126, 31.084564],
        [104.411467, 31.084058],
        [104.410587, 31.083516],
        [104.40975, 31.083084],
        [104.409176, 31.082832],
        [104.408366, 31.082501],
        [104.407433, 31.082202],
        [104.406483, 31.081954],
        [104.405775, 31.081835],
        [104.404931, 31.081678],
        [104.40432, 31.081554],
        [104.403799, 31.081481],
        [104.40293, 31.081352],
        [104.400919, 31.081012],
        [104.39962, 31.080815],
        [104.398381, 31.080608],
        [104.397271, 31.080433],
        [104.396343, 31.080263],
        [104.395045, 31.080057],
        [104.393779, 31.079841],
        [104.392614, 31.079675],
        [104.391252, 31.079446],
        [104.390259, 31.079248],
        [104.389707, 31.079129],
        [104.388806, 31.07888],
        [104.387969, 31.078559],
        [104.387668, 31.07843],
        [104.386792, 31.077945],
        [104.386057, 31.077449],
        [104.385107, 31.076636],
        [104.38449, 31.075951],
        [104.383761, 31.074908],
        [104.383423, 31.074233],
        [104.383149, 31.073502],
        [104.382908, 31.07262],
        [104.382795, 31.071862],
        [104.382758, 31.071048],
        [104.382709, 31.070221],
        [104.382693, 31.069358],
        [104.382672, 31.068609],
        [104.382618, 31.067781],
        [104.382622, 31.067522],
        [104.382606, 31.066856],
        [104.382563, 31.066011],
        [104.382531, 31.065023],
        [104.382488, 31.063722],
        [104.382435, 31.062472],
        [104.382343, 31.061503],
        [104.382247, 31.060519],
        [104.382172, 31.060023],
        [104.382086, 31.059274],
        [104.382011, 31.058787],
        [104.381893, 31.058134],
        [104.381759, 31.05739],
        [104.381646, 31.056788],
        [104.381464, 31.055988],
        [104.381292, 31.055271],
        [104.381169, 31.054683],
        [104.380992, 31.053934],
        [104.380841, 31.053277],
        [104.380584, 31.05211],
        [104.380332, 31.05097],
        [104.380117, 31.049927],
        [104.379988, 31.049233],
        [104.379854, 31.048286],
        [104.379779, 31.047872],
        [104.37972, 31.047344],
        [104.379624, 31.046383],
        [104.379559, 31.045547],
        [104.379533, 31.044724],
        [104.379522, 31.043782],
        [104.379549, 31.04295],
        [104.379575, 31.042058],
        [104.379613, 31.041254],
        [104.379651, 31.040431],
        [104.379688, 31.03965],
        [104.379715, 31.038813],
        [104.379688, 31.037945],
        [104.379651, 31.037172],
        [104.379538, 31.036437],
        [104.379404, 31.035729],
        [104.379264, 31.035155],
        [104.379028, 31.034396],
        [104.378771, 31.033748],
        [104.378492, 31.033077],
        [104.378106, 31.032314],
        [104.377794, 31.031716],
        [104.377462, 31.031082],
        [104.377194, 31.030604],
        [104.376856, 31.029914],
        [104.376518, 31.029262],
        [104.37618, 31.028572],
        [104.375836, 31.027961],
        [104.375466, 31.027244],
        [104.375139, 31.026573],
        [104.374629, 31.025635],
        [104.374061, 31.024656],
        [104.373508, 31.023856],
        [104.372843, 31.023097],
        [104.371947, 31.022196],
        [104.371035, 31.021456],
        [104.370054, 31.020817],
        [104.368873, 31.020187],
        [104.367602, 31.01964],
        [104.366288, 31.01918],
        [104.364104, 31.018436],
        [104.36279, 31.017971],
        [104.360618, 31.017227],
        [104.359303, 31.016707],
        [104.35808, 31.016082],
        [104.356793, 31.015273],
        [104.355886, 31.014597],
        [104.354626, 31.013429],
        [104.353687, 31.012482],
        [104.352769, 31.011539],
        [104.351294, 31.00999],
        [104.350339, 31.00907],
        [104.349422, 31.00811],
        [104.348537, 31.007213],
        [104.347614, 31.00628],
        [104.346702, 31.005332],
        [104.345796, 31.004427],
        [104.344873, 31.00347],
        [104.343966, 31.002541],
        [104.343076, 31.00164],
        [104.341467, 30.999989],
        [104.340683, 30.999134],
        [104.339793, 30.998136],
        [104.338827, 30.996996],
        [104.338366, 30.996426],
        [104.337631, 30.995506],
        [104.336901, 30.994499],
        [104.33615, 30.993446],
        [104.335442, 30.992448],
        [104.334825, 30.991533],
        [104.33401, 30.990393],
        [104.333468, 30.989625],
        [104.33246, 30.988185],
        [104.331816, 30.987252],
        [104.331103, 30.986286],
        [104.330764, 30.985807],
        [104.329986, 30.984694],
        [104.329235, 30.983628],
        [104.328613, 30.982763],
        [104.327883, 30.981701],
        [104.327363, 30.980946],
        [104.326778, 30.979948],
        [104.326263, 30.97895],
        [104.325807, 30.977938],
        [104.325346, 30.976917],
        [104.324987, 30.976076],
        [104.32438, 30.974972],
        [104.323726, 30.973946],
        [104.322964, 30.972985],
        [104.322363, 30.972355],
        [104.32158, 30.971564],
        [104.320631, 30.970814],
        [104.319874, 30.970294],
        [104.318785, 30.969627],
        [104.317627, 30.969015],
        [104.316307, 30.968284],
        [104.314794, 30.967493],
        [104.313582, 30.966835],
        [104.311597, 30.965823],
        [104.310074, 30.965004],
        [104.309215, 30.964475],
        [104.308459, 30.963951],
        [104.307949, 30.963546],
        [104.307225, 30.962824],
        [104.306479, 30.961858],
        [104.305943, 30.96109],
        [104.305508, 30.960363],
        [104.305106, 30.959747],
        [104.30479, 30.959218],
        [104.304425, 30.958606],
        [104.304039, 30.957962],
        [104.303727, 30.957442],
        [104.303121, 30.95648],
        [104.302381, 30.955271],
        [104.301973, 30.954548],
        [104.30148, 30.953752],
        [104.301029, 30.952998],
        [104.300487, 30.952124],
        [104.30008, 30.951434],
        [104.299624, 30.950656],
        [104.298985, 30.949621],
        [104.298352, 30.948572],
        [104.297666, 30.947436],
        [104.296759, 30.946005],
        [104.29611, 30.944947],
        [104.295445, 30.943861],
        [104.295016, 30.943217],
        [104.294511, 30.942646],
        [104.293701, 30.941814],
        [104.293009, 30.941188],
        [104.292178, 30.940608],
        [104.291411, 30.940102],
        [104.290756, 30.93978],
        [104.288975, 30.938878],
        [104.287468, 30.938146],
        [104.2861, 30.937323],
        [104.285129, 30.936679],
        [104.284265, 30.935998],
        [104.283638, 30.935464],
        [104.282763, 30.934585],
        [104.282157, 30.933909],
        [104.281712, 30.933347],
        [104.281116, 30.932579],
        [104.280601, 30.931939],
        [104.280253, 30.931534],
        [104.27992, 30.931157],
        [104.279491, 30.930701],
        [104.278992, 30.930223],
        [104.27859, 30.929836],
        [104.278155, 30.929473],
        [104.277565, 30.929054],
        [104.27705, 30.928663],
        [104.276465, 30.928336],
        [104.275849, 30.927977],
        [104.275393, 30.927729],
        [104.274797, 30.927388],
        [104.273821, 30.926864],
        [104.272893, 30.926376],
        [104.271943, 30.925888],
        [104.270978, 30.925345],
        [104.270055, 30.924917],
        [104.269406, 30.924512],
        [104.2688, 30.924162],
        [104.268301, 30.923831],
        [104.267732, 30.92344],
        [104.267507, 30.923274],
        [104.267044, 30.922912],
        [104.266379, 30.922313],
        [104.26544, 30.921347],
        [104.264651, 30.920408],
        [104.263895, 30.919285],
        [104.263407, 30.918457],
        [104.263026, 30.917624],
        [104.262747, 30.916966],
        [104.262377, 30.916133],
        [104.262044, 30.915406],
        [104.261738, 30.914688],
        [104.261508, 30.914186],
        [104.261154, 30.913399],
        [104.260859, 30.912718],
        [104.260526, 30.912055],
        [104.260311, 30.911682],
        [104.259872, 30.910941],
        [104.259544, 30.910472],
        [104.259163, 30.909961],
        [104.25874, 30.909469],
        [104.2583, 30.908981],
        [104.25771, 30.908387],
        [104.25728, 30.907996],
        [104.256943, 30.907729],
        [104.256454, 30.907337],
        [104.25588, 30.906937],
        [104.255398, 30.906624],
        [104.254743, 30.90621],
        [104.254201, 30.905924],
        [104.253359, 30.905446],
        [104.252892, 30.905197],
        [104.25212, 30.904778],
        [104.251369, 30.904378],
        [104.250376, 30.90383],
        [104.249706, 30.903467],
        [104.249137, 30.903158],
        [104.248467, 30.902776],
        [104.247914, 30.902482],
        [104.247222, 30.902104],
        [104.246369, 30.901625],
        [104.245463, 30.901151],
        [104.244637, 30.900696],
        [104.243773, 30.900235],
        [104.24278, 30.899692],
        [104.241928, 30.899232],
        [104.241107, 30.898772],
        [104.240265, 30.898334],
        [104.238714, 30.897473],
        [104.237926, 30.897045],
        [104.236762, 30.89641],
        [104.235077, 30.895499],
        [104.233774, 30.894799],
        [104.232867, 30.894288],
        [104.231741, 30.89369],
        [104.230979, 30.893248],
        [104.230228, 30.892801],
        [104.22952, 30.892378],
        [104.228769, 30.89183],
        [104.227782, 30.890987],
        [104.227304, 30.890504],
        [104.22687, 30.89003],
        [104.22628, 30.88933],
        [104.225963, 30.888902],
        [104.225529, 30.888235],
        [104.224976, 30.887213],
        [104.224622, 30.886402],
        [104.224364, 30.885624],
        [104.224112, 30.884851],
        [104.223941, 30.884059],
        [104.223769, 30.883355],
        [104.223624, 30.882738],
        [104.223474, 30.882084],
        [104.223227, 30.880965],
        [104.22305, 30.880252],
        [104.222857, 30.879372],
        [104.222675, 30.878534],
        [104.222471, 30.877618],
        [104.222272, 30.876803],
        [104.221988, 30.875601],
        [104.22173, 30.874658],
        [104.221366, 30.873649],
        [104.221049, 30.872825],
        [104.220738, 30.872116],
        [104.220287, 30.8712],
        [104.219955, 30.870551],
        [104.219477, 30.869676],
        [104.219156, 30.869063],
        [104.218882, 30.868483],
        [104.218549, 30.867774],
        [104.218303, 30.867189],
        [104.218051, 30.866462],
        [104.217745, 30.865504],
        [104.21753, 30.864505],
        [104.217337, 30.863533],
        [104.217257, 30.862534],
        [104.217235, 30.861719],
        [104.217257, 30.861088],
        [104.217267, 30.860218],
        [104.217321, 30.859117],
        [104.217369, 30.85815],
        [104.217412, 30.857132],
        [104.217498, 30.855788],
        [104.217595, 30.853701],
        [104.217702, 30.851869],
        [104.217723, 30.850266],
        [104.217723, 30.849225],
        [104.217623, 30.848162],
        [104.217522, 30.847485],
        [104.217323, 30.846407],
        [104.21713, 30.845523],
        [104.216931, 30.844809],
        [104.216626, 30.843847],
        [104.216127, 30.842589],
        [104.215719, 30.841502],
        [104.215032, 30.83984],
        [104.214576, 30.838688],
        [104.213879, 30.837016],
        [104.21279, 30.834391],
        [104.211755, 30.831774],
        [104.210762, 30.829043],
        [104.209947, 30.826523],
        [104.209647, 30.825344],
        [104.208928, 30.822331],
        [104.208241, 30.819373],
        [104.207501, 30.816176],
        [104.206626, 30.812808],
        [104.206052, 30.811279],
        [104.205312, 30.809689],
        [104.204556, 30.808344],
        [104.20366, 30.807031],
        [104.202743, 30.805814],
        [104.201734, 30.804681],
        [104.200844, 30.803755],
        [104.199738, 30.802635],
        [104.198875, 30.801769],
        [104.198242, 30.801161],
        [104.196944, 30.799884],
        [104.196246, 30.799161],
        [104.194712, 30.797659],
        [104.1935, 30.796414],
        [104.192454, 30.795332],
        [104.191676, 30.794461],
        [104.190657, 30.79323],
        [104.189868, 30.792207],
        [104.189149, 30.791161],
        [104.188441, 30.790129],
        [104.186987, 30.787954],
        [104.186156, 30.786737],
        [104.184954, 30.784981],
        [104.184192, 30.783843],
        [104.182921, 30.781926],
        [104.1821, 30.780631],
        [104.180845, 30.778474],
        [104.179863, 30.776529],
        [104.179418, 30.775612],
        [104.179021, 30.77475],
        [104.178715, 30.774035],
        [104.178393, 30.773326],
        [104.177846, 30.772095],
        [104.177449, 30.771169],
        [104.177127, 30.770422],
        [104.1765, 30.76903],
        [104.175979, 30.767804],
        [104.175271, 30.7662],
        [104.174805, 30.765135],
        [104.174456, 30.764351],
        [104.174021, 30.763392],
        [104.173431, 30.762217],
        [104.172841, 30.761074],
        [104.172214, 30.759931],
        [104.1715, 30.758833],
        [104.170905, 30.757856],
        [104.170116, 30.756681],
        [104.169333, 30.755547],
        [104.16855, 30.754408],
        [104.167745, 30.753242],
        [104.16686, 30.751946],
        [104.166109, 30.750877],
        [104.165583, 30.750084],
        [104.165176, 30.749535],
        [104.164655, 30.748691],
        [104.164194, 30.74794],
        [104.163754, 30.747258],
        [104.16318, 30.74634],
        [104.162767, 30.745455],
        [104.162322, 30.744279],
        [104.162145, 30.743602],
        [104.161909, 30.742481],
        [104.161791, 30.741559],
        [104.161646, 30.740236],
        [104.161496, 30.738908],
        [104.161335, 30.737469],
        [104.161281, 30.737017],
        [104.161211, 30.736178],
        [104.161136, 30.73539],
        [104.161045, 30.73456],
        [104.160964, 30.733813],
        [104.160836, 30.732941],
        [104.160643, 30.732167],
        [104.160337, 30.731157],
        [104.160079, 30.730516],
        [104.159731, 30.72982],
        [104.15921, 30.728976],
        [104.158856, 30.728506],
        [104.158368, 30.727892],
        [104.157692, 30.727196],
        [104.157086, 30.726656],
        [104.156517, 30.726163],
        [104.155863, 30.725711],
        [104.155332, 30.725388],
        [104.15479, 30.725098],
        [104.154259, 30.724821],
        [104.153379, 30.724429],
        [104.152532, 30.724143],
        [104.151207, 30.723673],
        [104.149613, 30.723156],
        [104.148101, 30.722672],
        [104.14721, 30.722391],
        [104.146287, 30.72205],
        [104.145424, 30.721694],
        [104.144662, 30.721376],
        [104.144077, 30.721044],
        [104.143611, 30.720749],
        [104.14286, 30.720288],
        [104.142302, 30.71985],
        [104.141594, 30.719236],
        [104.141148, 30.718785],
        [104.140558, 30.718176],
        [104.140183, 30.717724],
        [104.139845, 30.717304],
        [104.139367, 30.716682],
        [104.138933, 30.716114],
        [104.138536, 30.715593],
        [104.138203, 30.715127],
        [104.137812, 30.714648],
        [104.137179, 30.713795],
        [104.136862, 30.713356],
        [104.13624, 30.712526],
        [104.135875, 30.712042],
        [104.135269, 30.711276],
        [104.134518, 30.710326],
        [104.133778, 30.709607],
        [104.133225, 30.709146],
        [104.132592, 30.708657],
        [104.131423, 30.7079],
        [104.130602, 30.707457],
        [104.129711, 30.707047],
        [104.128826, 30.70671],
        [104.127952, 30.706461],
        [104.126965, 30.706166],
        [104.12631, 30.70594],
        [104.125436, 30.705668],
        [104.124476, 30.705396],
        [104.123408, 30.705059],
        [104.122255, 30.704713],
        [104.1213, 30.704436],
        [104.120409, 30.70421],
        [104.119782, 30.704123],
        [104.119063, 30.704035],
        [104.11814, 30.704012],
        [104.117395, 30.704035],
        [104.116139, 30.703984],
        [104.114777, 30.703989],
        [104.114085, 30.703994],
        [104.113151, 30.703998],
        [104.111488, 30.704012],
        [104.110206, 30.70398],
        [104.10915, 30.703975],
        [104.106725, 30.703971],
        [104.104815, 30.703943],
        [104.104064, 30.703786],
        [104.103721, 30.703569],
        [104.10349, 30.703376],
        [104.103329, 30.703154],
        [104.103206, 30.702919],
        [104.103163, 30.702698],
        [104.103147, 30.702462],
        [104.103141, 30.70219],
        [104.103302, 30.701807],
        [104.103512, 30.701457],
        [104.103608, 30.701263],
      ]
      marker = new window.AMap.Marker({
        map: this.AutoNaviMap,
        position: [104.421316, 31.131339],
        icon: 'https://webapi.amap.com/images/car.png',
        offset: new window.AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: 90,
      })

      // 绘制轨迹
      new window.AMap.Polyline({
        map: this.AutoNaviMap,
        path: lineArr,
        showDir: true,
        strokeColor: '#28F', //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new window.AMap.Polyline({
        map: this.AutoNaviMap,
        // path: lineArr,
        strokeColor: '#AF5', //线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6, //线宽
        // strokeStyle: "solid"  //线样式
      })

      marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })

      this.AutoNaviMap.setFitView() //全浏地图
      marker.moveAlong(lineArr, 50) //开始动画
    },
  },
}
</script>
